import axios from 'axios';

/**
 * 文件服务 - 使用服务器文件系统存储功能
 */

// API基础URL
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://life-travel.cn:88/api' 
  : 'http://localhost:3001/api';

// 文件存储服务
const fileStorage = {
  // 保存文件内容
  async saveFile(fileId, content, options = {}) {
    try {
      console.log('正在保存文件到服务器:', fileId);
      
      const response = await axios.post(`${API_BASE_URL}/files`, {
        fileId,
        content,
        options: {
          maxReads: options.maxReads || 1, // 默认只能读取一次
          expiresAt: options.expiresAt || this._getDefaultExpiry() // 默认24小时后过期
        }
      });
      
      return response.data.success;
    } catch (error) {
      console.error('保存文件失败:', error);
      throw new Error('保存分享内容失败');
    }
  },
  
  // 读取文件内容
  async readFile(fileId) {
    try {
      console.log('正在从服务器读取文件:', fileId);
      
      const response = await axios.get(`${API_BASE_URL}/files/${fileId}`);
      return response.data;
    } catch (error) {
      console.error('读取文件失败:', error);
      if (error.response && error.response.status === 404) {
        return { error: '文件不存在或已被删除' };
      }
      return { error: '读取文件失败' };
    }
  },
  
  // 删除文件
  async deleteFile(fileId) {
    try {
      console.log('正在从服务器删除文件:', fileId);
      
      const response = await axios.delete(`${API_BASE_URL}/files/${fileId}`);
      return response.data.success;
    } catch (error) {
      console.error('删除文件失败:', error);
      return false;
    }
  },
  
  // 生成唯一文件ID
  generateFileId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
  },
  
  // 获取默认过期时间（24小时后）
  _getDefaultExpiry() {
    const date = new Date();
    date.setHours(date.getHours() + 24);
    return date.toISOString();
  }
};

export default fileStorage;
